import {lookup} from "./pages/administrationaccount";
import {roles} from "./utils/roles";

function descendingComparator(a, b, orderBy) {
    const value = orderBy==="ownerEmail"?"UNASSIGNED":null;
    const aSort = a[orderBy] ? a[orderBy].toString().toUpperCase():value;
    const bSort = b[orderBy] ? b[orderBy].toString().toUpperCase():value;

    if (bSort < aSort) {
        return -1;
    }
    if (bSort > aSort) {
        return 1;
    }
    return 0;
}
  
export function filterSort(array, filters, orderBy, orderType) {
let arrayFiltered = array;
// filter
Object.keys(filters).forEach((value) => {
    const filterValue = filters[value];
    const filter =
    typeof filterValue === 'object' ? filterValue[0] : filterValue;
    if (filter) {
    arrayFiltered = arrayFiltered.filter((a) => {
        const aUpper = a[value] && a[value].toString().toUpperCase();
        const filterUpper = filter && filter.toString().toUpperCase();

        return aUpper.indexOf(filterUpper) > -1;
    });
    }
});
return arrayFiltered.sort((a, b) => {
    return orderType === 'descending'
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
    });
}

export const getEditRoles = (businessName, currentUserRole) => {
    if(currentUserRole === roles.hbAdministrator || currentUserRole === roles.rmAdministrator) {
        return lookup[businessName] && lookup[businessName].length ? lookup[businessName] : lookup['Renew'];
    } else {
        return lookup[businessName] && lookup[businessName].length ? lookup[businessName] : lookup['Darwin'];
    }
}

export const sort = (data, sortBy) => {
    return data.sort((a, b) => {
        if (String(a[sortBy.id]).toUpperCase() > String(b[sortBy.id]).toUpperCase()) {
            return sortBy.type === 'ascending' ? 1 : -1;
        } else if (String(b[sortBy.id]).toUpperCase() > String(a[sortBy.id]).toUpperCase()) {
            return sortBy.type === 'ascending' ? -1 : 1;
        } else {
            return 0;
        }
    });
}
